import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/HomePage/PressSection.styl'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

type PressSource =
  | 'wall_street_hor'
  | 'wall_street_vert'
  | 'forbes'
  | 'cnbc_hor'
  | 'cnnmoney'
  | 'businessinsider'

const pressSources: PressSource[] = [
  'wall_street_hor',
  'wall_street_vert',
  'forbes',
  'cnbc_hor',
  'cnnmoney',
  'businessinsider',
]

const PressSection: FC = () => {
  const pressChildren = pressSources.map((pressSource) => {
    const className = cn(styles.logoWrapper, styles[pressSource])
    return (
      <div key={ pressSource } className={ className }>
        <img
          src={ `/images/media-logos/${ pressSource }.svg` }
          alt={ pressSource }
          className={ styles.logo }
        />
      </div>
    )
  })

  return (
    <NavigationLink to='press' className={ styles.pressSection }>
      <div className={ styles.contentWrapper }>
        { pressChildren }
      </div>
    </NavigationLink>
  )
}

export default PressSection
